/* Copyright Information: Created by BuyGroup */
import React from "react";
import {
  Button,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

const DeleteOrderLineItem = ({
  customerOrderLineId,
  deleteOrderLineItem,
  closedDeleteModal,
  removeOrderLineItem,
  isLoadingRemoveOrderLineItem,
}) => {
  return (
    <div>
      <Modal isOpen={deleteOrderLineItem} style={{ overlay: { opacity: 0.1 } }}>
        <ModalHeader toggle={closedDeleteModal}>
          <h5 className="modal-title f-w-600" id="exampleModalLabel2">
            Confirmation
          </h5>
        </ModalHeader>
        <ModalBody>
          <FormGroup className="form-group mb-3 row">
            <Label className="col-xl-12 col-sm-12 mb-0">
              Are you sure you want to delete this Order Line Item?
            </Label>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            type="submit"
            color="primary"
            onClick={() => removeOrderLineItem(customerOrderLineId)}
            disabled={isLoadingRemoveOrderLineItem}
          >
            {isLoadingRemoveOrderLineItem
              ? "Please Wait..."
              : "Yes, Delete it!"}
          </Button>
          <Button type="button" color="light" onClick={closedDeleteModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DeleteOrderLineItem;
/* Copyright Information: Created by BuyGroup */
